import { Type } from "@sinclair/typebox";
import SchemaValidator from "../schema-validator";
import { OptionalOrNull } from "../shared-schemas";

const authenticated = new SchemaValidator(
	Type.Object({
		authenticated: Type.Boolean(),
	}),
);

const accessCode = new SchemaValidator(
	Type.Object({
		code: Type.String(),
	}),
);

const accessControlAuthCode = new SchemaValidator(
	Type.Object({
		authCode: Type.String(),
	}),
);

const refreshTokenInfo = new SchemaValidator(
	Type.Object({
		refreshToken: Type.String(),
		accountId: Type.String(),
		currentUserId: Type.String(),
	}),
);

const account = new SchemaValidator(
	Type.Object({
		id: Type.String(),
		email: OptionalOrNull(Type.String()),
		currentUserId: OptionalOrNull(Type.String()),
		userIds: Type.Array(Type.String()),
	}),
);

const getAccountPortals = new SchemaValidator(
	Type.Object({
		entries: Type.Array(
			Type.Object({
				accountId: Type.String(),
				userId: Type.String(),
				role: Type.String(),
				instituteId: Type.String(),
				instituteName: OptionalOrNull(Type.String()),
				institutePlatform: OptionalOrNull(Type.String()),
				instituteOrigin: OptionalOrNull(Type.String()),
				courseId: Type.String(),
				lmsCourseId: OptionalOrNull(Type.String()),
				courseCode: OptionalOrNull(Type.String()),
				courseName: OptionalOrNull(Type.String()),
			}),
		),
		currentPage: Type.Number(),
		totalElements: Type.Number(),
		totalPages: Type.Number(),
	}),
);

export default {
	authenticated,
	accessCode,
	accessControlAuthCode,
	refreshTokenInfo,
	account,
	getAccountPortals,
};
